import React, {useEffect, useState} from 'react'
import {useDispatch, useSelector} from "react-redux";

import classes from './Registration.module.scss'
import {cardCreation} from '../../../../store/reducers/RegistrationReducer/RegistrationReducer'
import QRCode from '../../../common/QrCodeGenerator';
import {DirectionService} from "../../../../api/directionService";
import Form from "./DirectionForm";
import {getAge} from "../../../../utils/getAge";

const RegistrationForm = ({patientInfo, patientData, patientId, pasteHandler, isCopied, outside}) => {
    const values = useSelector(state => state.regForm)
    const dispatch = useDispatch()
    const [code, setCode] = useState(false)
    const [data, setData] = useState({})
    const [departaments, setDepartaments] = useState([])

    const [registrationCard, setRegistrationCard] = useState({
        "patientData": [
            "name",
            "lastName",
            "middleName",
            "birthDate",
            "gender",
            "cardNumber",
            "patientNumber",
            "phoneNumber"
        ],
        "directionData": [
            "activeDoc",
            "research",
            "biopsy",
            "clinicalConclusion",
            "clinicalInfo",
            "markedMaterial",
            "operationDate",
            "operationName",
            "status",
            "quantityMaterial",
            "departmentId",
            "hospitalId",
        ]
    })

    useEffect(() => {
        if (registrationCard.activeDoc !== ''){
            dispatch(cardCreation({credential: {...registrationCard, "qr": `${<QRCode value={JSON.stringify(registrationCard)}/>}`}}))
        }
        <QRCode value={JSON.stringify(registrationCard)}/>
    }, [registrationCard])

    useEffect(() => {
        if (patientInfo?.id || Object.keys(patientInfo).length > 2){
            const matchedData = values?.fields?.map(key => {
                const item = patientInfo[key?.name]
                if (item){
                    if (key?.name == "birthDate"){
                        return {...key, value: getAge(item), show: true}
                    } else {
                        return {...key, value: item, show: true}
                    }
                } else {
                    return key
                }
            })

            setData({...values, fields: matchedData})
        } else {
            setData({
                ...values,
                fields: !patientInfo?.phoneNumber ? values?.fields?.filter(e => e?.name !== 'phoneNumber') : values?.fields?.map(e => e?.name == "phoneNumber" ? {
                    ...e,
                    value: '+' + patientInfo?.phoneNumber,
                    show: true
                } : e)
            })
        }
    }, [values, patientInfo])

    useEffect(() => {
        const fetchData = async() => {
            const response = await DirectionService.getOptions();

            if (response?.data){
                setData((prevData) => ({
                    ...prevData,
                    fields: prevData?.fields?.map((item) => {
                            let dataSource;

                            if (item.name === 'departmentId'){
                                dataSource = response?.data?.departments;
                            } else if (item.name === 'hospitalId'){
                                dataSource = response?.data?.hospitals;
                            } else if (item.name === 'antibodies'){
                                dataSource = response?.data?.antibodies;
                            }

                            return dataSource
                                ? {
                                    ...item,
                                    props: dataSource.map(el => ({
                                        value: el.name,
                                        label: el.name,
                                        id: el.id,
                                        type: 'option',
                                        departments: el.departments || null,
                                        registrationType: el.registrationType || null,
                                    }))
                                }
                                : {...item};
                        }
                    )
                }));

                if (!!response?.data?.departments){
                    setDepartaments(
                        response?.data?.departments.map(el => ({
                            value: el.name,
                            label: el.name,
                            id: el.id,
                            type: 'option',
                            registrationType: 'BASIC',
                        }))
                    )
                }
            }
        };
        fetchData();
    }, [values]);

    return (
        <div className={classes.registration}>
            {code && <QRCode value={JSON.stringify(registrationCard)}/>}
            <Form
                values={data}
                patientData={patientData}
                patientNumber={patientId}
                pasteHandler={pasteHandler}
                departments={departaments}
                isCopied={isCopied}
                outside={outside}
            />
        </div>
    )
}

export default RegistrationForm